import { createStore } from "vuex";
import api from "@/services/Api";
export default createStore({
    state() {
        return {
            isAuthenticated: false,
            user: {
                loaded: false,
                name: null,
                username: null,
                email: null,
                cloudApiUrl: null,
            },
            schoolLoading: false,
            school: {
                loaded: false,
                city: '',
                email: '',
                facebook: '',
                instagram: '',
                logo: '',
                name: '',
                phone: '',
                snapChat: '',
                street: '',
                tikTok: '',
                website: '',
                youtube: '',
                zipCode: '',
            },
            toastMessage: {
                show: false,
                duration: 0,
                title: '',
                message: '',
                action: null,
                args: ''
            },
            QRScanner: {
                show: false,
                title: '',
                type: ''
            },
            showHelpModal: false,
            pushNotificationAction: null,
            themePreference: localStorage.getItem('themePreference') ?? 'system'
        };
    },
    actions: {
        loadSchoolInfo({ commit }) {
            return new Promise((resolve, reject) => {
                commit('setSchoolLoadingStatus', true);
                api
                    .get('drivingschool')
                    .then((response) => {
                    commit('setSchoolInfo', { ...response.data, loaded: true });
                    resolve(response.data);
                })
                    .catch((error) => reject(error))
                    .finally(() => commit('setSchoolLoadingStatus', false));
            });
        }
    },
    mutations: {
        setAuthState(state, authState) {
            state.isAuthenticated = authState;
            console.log('Store: setAuthState', authState);
        },
        setUserInfo(state, userInfo) {
            state.user = userInfo;
        },
        setSchoolLoadingStatus(state, status) {
            state.schoolLoading = status;
        },
        setSchoolInfo(state, schoolInfo) {
            state.school = schoolInfo;
            state.school = {
                city: schoolInfo.city,
                email: schoolInfo.email,
                facebook: schoolInfo.facebook,
                instagram: schoolInfo.instagram,
                logo: schoolInfo.logo,
                name: schoolInfo.name,
                phone: schoolInfo.phone,
                snapChat: schoolInfo.snapChat,
                street: schoolInfo.street,
                tikTok: schoolInfo.tikTok,
                website: schoolInfo.website,
                youtube: schoolInfo.youtube,
                zipCode: schoolInfo.zipCode,
                loaded: schoolInfo.loaded || false,
            };
        },
        showQRScanner(state, { title, type }) {
            state.QRScanner.show = true;
            state.QRScanner.title = title || '';
            state.QRScanner.type = type || '';
        },
        closeQRScanner(state) {
            state.QRScanner.show = false;
            state.QRScanner.title = '';
            state.QRScanner.type = '';
        },
        setHelpModalShow(state, value = false) {
            state.showHelpModal = value;
        },
        showToast(state, { title, message, duration, action, args }) {
            state.toastMessage.show = true;
            state.toastMessage.title = title;
            state.toastMessage.message = message;
            state.toastMessage.duration = duration || 3000;
            state.toastMessage.action = action || null;
            state.toastMessage.args = args || '';
        },
        closeToast(state) {
            state.toastMessage.show = false;
        },
        setPushNotificationAction(state, data) {
            state.pushNotificationAction = data;
        },
        setThemePreference(state, preference) {
            state.themePreference = preference;
        }
    }
});
